module.exports = __webpack_public_path__ + "img/face1.b52cfc22.jpg";